import { Box, Divider, IconButton } from '@mui/material';
import React from 'react'
import { toast } from 'react-toastify';
import { DocumentUploadService } from '../../../../Component/Api/DocumentUpload/DocumentUploadService';
import { MDAlert } from '../../../../Component/Common/Components/MDAlert';
import { MDTypography } from '../../../../Component/Common/Components/MDTypography';
import config from '../../../../config';
import CloseIcon from '@mui/icons-material/Close';
import { Support } from '../../../../Component/Model/Dto/Support/SupportRequest';

interface IProps {
    documentsUploaded : Support.TicketDocumentDto[];
    afterDelete: () => void;
    scorecardId: string;
    allowEdit : boolean;
}

export const Documents = (props: IProps) => {

    const getDocument = (id: number) => {
        const url = `${config.apiUrl}/DocumentUpload/Get?id=${id}&scorecardId=${props.scorecardId}`;
        window.open(url);
    }

    const deleteDocument = async (id: number) => {
        try {
            await DocumentUploadService.DeleteDocument(id);
            toast.success("File deleted");
            props.afterDelete();
        } catch (error) {
        }
    }

    return (
        <Box>
            <MDTypography variant='h5'>
                Documents
            </MDTypography>
            <Divider sx={{ mt: 0 }} />
            <Box>
                <Box display="flex" color="white">
                    <MDTypography component='span' variant='body' fontSize='0.93rem' fontWeight='light'>
                        <p> The maximum file size for any upload is <strong>20MB</strong> per file.</p>
                        <MDTypography component='span' variant='body' fontWeight='bold' fontSize='0.95rem' mb={1} display="flex" alignItems="center">
                            Only the following file types are allowed:
                        </MDTypography>
                        <p> *.jpeg / *.jpg / *.png / *.gif / *.bmp / *.tiff / *.doc / *.docx / *.xls / *.xlsx / *.pdf / *.zip / *.rar / </p>
                    </MDTypography>
                </Box>
            </Box>
            <Box>
                <MDAlert color='info' >
                    <MDTypography component='span' variant='body' fontSize='0.83rem' fontWeight='regular' color style={{ width: '100%' }}>
                        <MDTypography component='span' variant='body' fontSize='0.87rem' fontWeight='medium' mb={1} display="flex" alignItems="center" color>
                            The following files have been uploaded:
                        </MDTypography>
                        <ul>{
                            props.documentsUploaded.map((doc, index) => {
                                return <li key={index} style={{ margin: '3px', marginBottom: '10px' }}>
                                    <button
                                        style={{ background: 'none', color: 'inherit', cursor: 'pointer', border: 'none' }}
                                        onClick={() => getDocument(doc.Id as number)}>{doc.Name}
                                    </button>
                                    {props.allowEdit && <IconButton
                                        aria-label="close" size="small"
                                        style={{ float: 'right', color: 'inherit' }}
                                        onClick={() => deleteDocument(doc.Id as number)}>
                                        <CloseIcon fontSize="small" />
                                    </IconButton>}
                                </li>;
                            })
                        }</ul>
                    </MDTypography>
                </MDAlert>
            </Box>
        </Box>
    )
}
